import { IStateService } from 'angular-ui-router';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';
import { Auth } from './../../../ng2/shared/auth/auth.service';

angular.module('nv.routes.auth').config(configBlock);

function configBlock($stateProvider) {
  $stateProvider.state('login', {
    url: '/login',
    template: '<login></login>',
    data: {
      roles: USER_ROLE_PERMISSIONS_FOR_STATES.login,
    },
    onEnter($state: IStateService, Auth: Auth) {
      if (Auth.isAuthenticated()) {
        return $state.go('main.home');
      } else {
        // clear auth values from local storage if the user is not authenticated (Carlos)
        Auth.clearLocalStorageOfAuthVals();
      }
    },
    onExit(SpinnerModal) {
      SpinnerModal.deactivateSpinner();
    },
  });
}
